import store from '@/store';

/**
 * Local Vue 3 replacement for @waju/vue-guard (0.0.1, Vue-2-only).
 * Only the <v-guard> component was used by this app (no meta.guard router
 * hooks, no $permitsAll/$permitsAny) — semantics preserved verbatim:
 * renders its default slot iff the user holds the given permission(s);
 * `permissions` may be an array or a comma-separated string; `all`
 * switches between every-permission and any-permission matching.
 */
export function isPermitted(usersPermissions, permissions, all) {
	const wanted = Array.isArray(permissions)
		? permissions
		: String(permissions).trim().split(',');
	const held = (usersPermissions || []).map((s) => String(s).trim());
	const hits = wanted.filter((p) => held.includes(String(p).trim()));
	return all ? hits.length >= wanted.length : hits.length > 0;
}

export default {
	install(app) {
		app.component('v-guard', {
			props: {
				permissions: { type: [Array, String], default: () => [] },
				all: { type: Boolean, default: false },
			},
			render() {
				const userPermissions = store.getters.permissions || [];
				if (isPermitted(userPermissions, this.permissions, this.all)) {
					// Under @vue/compat $slots.default is a v2-style object;
					// in pure Vue 3 it is a function. Support both.
					const slot = this.$slots.default;
					return typeof slot === 'function' ? slot() : (slot ?? null);
				}
				return null;
			},
		});
	},
};
